import {siteGroup} from "@signals";
import {batch} from "@preact/signals-react";
import React from 'react'
import {BACKEND_APIS} from "../../../../@constants";
import {AutocompleteAsyncSeeker} from "@ui-seeker/core";
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'

export default function AppCommonFiltersSiteGroupAutocomplete({ onOptions, onFinishAjax, ...props }) {
    return <AutocompleteAsyncSeeker
        label={"Site Group"}
        placeholder={"All site Group"}
        urlAjax={`${BACKEND_APIS.CRUD}/user/sites_group?selectorFormat=true`}
        value={siteGroup.value || null}
        onChange={e => batch(() => {
            siteGroup.value = e.target.value
        })}
        onFinishAjax={chainFinish(onFinishAjax, onOptions)}
        {...props}
    />
}